import { CountryCode } from '@weave/schema-gen-ts/dist/schemas/forms-digital/weave_digital_forms.pb';
import { Options } from '@frontend/fetch';
import { i18next } from '@frontend/i18n';
import { PostalCodeLocale } from '@frontend/design-system';

export const COUNTRIES = [
  {
    label: i18next.t('US', { ns: 'digital-forms-experience' }),
    value: CountryCode.US,
  },
  {
    label: i18next.t('Canada', { ns: 'digital-forms-experience' }),
    value: CountryCode.CA,
  },
];

export const ALLOWED_COUNTRY_CODES = COUNTRIES.map((country) => country.value);
export const DEFAULT_POSTAL_CODE_LOCALE = PostalCodeLocale.US;

export const DEFAULT_DFX_HTTP_OPTIONS: Options = {
  skipValidation: true,
};
